import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { doUpdateWeekAppointment, openCloseModalConflictWeek, setAppointmentEditWeek } from "./actions";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalConflictWeek extends React.PureComponent {
  handleClose = () => {
    this.props.dispatch(setAppointmentEditWeek({ config: {} }));
    this.props.dispatch(openCloseModalConflictWeek(false));
  }

  handleAccept = () => {
    this.props.dispatch(doUpdateWeekAppointment(this.props.appointmentEditWeek));
  }

  render() {
    return (
      <Popup
        visible={this.props.isOpenModalConflictWeek}
        title="Conflictos en cupos agendados"
        onHiding={this.handleClose}
        showCloseButton
        dragEnabled={false}
        height={250}
        width={550}
        contentComponent={() => (
          <div>
            {this.props.isLoading && <LoadingOverlay />}
            <div className="text-center">
              ¿Está seguro de modificar la capacidad y <span className="red-text">eliminar</span> cupos ya agendados?
            </div>
            <div className="text-center" style={{ marginTop: 20 }}>
              Existen cupos agendados que se verán afectados, estos serán enviados como solicitudes para
              que él Call Center los pueda agendar.
            </div>
            <div className="button-row">
              <div>
                <Button
                  text="Cancelar"
                  onClick={this.handleClose}
                />
              </div>
              <div>
                <Button
                  text="Aceptar"
                  type="danger"
                  onClick={this.handleAccept}
                />
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.bloqueosSel.isLoading,
  appointmentEditWeek: state.bloqueosSel.appointmentEditWeek,
  isOpenModalConflictWeek: state.bloqueosSel.isOpenModalConflictWeek,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalConflictWeek);
